/* ===========================
IMPORTS
=========================== */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// IMPORT - COMPONENTS
import ModalFirmware from './ModalFirmware';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
import Modal from '../Elements/Modal';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class BundlesDetails extends Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      id: (this.props.id || null),
      data: {},
      name: '',
      description: '',
      modals: {
        schedule: false,
        firmware: false,
      },
      submitted: false,
      modalData: null,
      modalSubmitted: false,
      loadingModal: false,
      loading: true,
      errorsForm: null,
    };

    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.get = this.get.bind(this);
    this.updateLoadingModal = this.updateLoadingModal.bind(this);
    this.setModalSubmitted = this.setModalSubmitted.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {function} callback
   * @param {function} failback
   */
  get(callback, failback) {
    this.setState({
      loading: true,
    }, () => {
      this.requestGet(
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.bundle) {
            this.setState({
              submitted: false,
              loading: false,
              data: response.bundle,
              name: response.bundle.name,
              description: response.bundle.description,
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          } else {
            this.setState({
              submitted: false,
              loading: false,
            });
          }
        },
      );
    });
  }

  /**
   * Main API request to fetch bundle
   * @param {function} callback
   * @param {function} failback
   */
  requestGet(callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.id}`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * API request to update bundle
   * @param {function} callback
   * @param {function} failback
   */
  requestUpdate(callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.id}`,
      'put',
      JSON.stringify({
        name: this.state.name,
        description: this.state.description,
      }),
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * Show / hide modal windows
   * @param {boolean} type
  */
  handleShowModal(type, show) {
    const { modals } = this.state;
    modals[type] = show;
    this.setState({
      modals,
    });
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    this.setState({
      errorsForm: null,
      submitted: true,
    }, () => {
      this.requestUpdate(
        // callback
        () => {
          this.get();
        },
        // failback
        (error) => {
          this.setState({
            errorsForm: error,
            submitted: false,
          });
        },
      );
    });

    event.preventDefault();
  }

  /**
   * @param {boolean} submitted
   */
  setModalSubmitted(submitted) {
    this.setState({
      modalSubmitted: submitted,
    });
  }

  /**
   * @param {boolean} show
   */
  updateLoadingModal(show) {
    this.setState({
      loadingModal: show,
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      (this.state.loading)
        ? (<Loader />)
        : (
          <div className="row">
            <div className="col col-7">
              <h3>Overview</h3>
              <form onSubmit={this.handleSubmit}>
                <table className="table">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td><input type="text" onChange={this.handleChange} className="form-control" disabled={this.state.submitted} name="name" value={this.state.name} placeholder="Name" /></td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td><textarea onChange={this.handleChange} className="form-control" disabled={this.state.submitted} name="description" value={this.state.description} placeholder="Description" /></td>
                    </tr>
                    {(this.state.errorsForm)
                      ? (
                        <tr>
                          <td colSpan="2">
                            <div className="alert alert-danger">
                              {(Object.keys(this.state.errorsForm).map((item) => (
                                <span key={`item-${item}`}>
                                  <strong>{item}</strong>
&nbsp;
                                  {this.state.errorsForm[item]}
                                </span>
                              )))}
                            </div>
                          </td>
                        </tr>
                      )
                      : null}
                    <tr>
                      <th>&nbsp;</th>
                      <td>
                        <button disabled={this.state.submitted} type="submit" className="btn btn-rounded btn-primary">{(this.state.submitted) ? 'Loading...' : 'Save'}</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>

              <h3>Details</h3>
              <table className="table">
                <tbody>
                  <tr>
                    <th>Firmware</th>
                    <td>
                      <button disabled={this.state.submitted} type="button" className="btn btn-rounded btn-primary" onClick={() => { this.setState((prevState) => ({ modalData: prevState.data }), () => { this.handleShowModal('firmware', true); }); }}>
                        <i className="fa fa-edit" />
&nbsp;Edit
                      </button>
&nbsp;
                      {(this.state.data.firmware
                        && Object.keys(this.state.data.firmware).length > 0)
                        ? (this.state.data.firmware.name)
                        : 'None'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col col-12">
              {(this.state.modals.firmware)
                ? (
                  <Modal
                    size="modal-lg"
                    title="Firmware"
                    loading={this.state.loadingModal}
                    updateLoadingModal={this.updateLoadingModal}
                    submitted={this.state.modalSubmitted}
                    cancel={(event) => {
                      this.handleShowModal('firmware', false);
                      event.preventDefault();
                    }}
                    buttonCloseLabel="Close"
                    buttonCloseAction={(event) => {
                      this.handleShowModal('firmware', false);
                      event.preventDefault();
                    }}
                    buttonSubmitAction={(event) => {
                      const form = document.getElementById('modal-view-firmware');
                      form.getElementsByTagName('button')[0].click();
                      event.preventDefault();
                    }}
                  >
                    <ModalFirmware
                      id="modal-view-firmware"
                      loading={this.state.loadingModal}
                      data={this.state.modalData}
                      updateLoadingModal={this.updateLoadingModal}
                      submitted={this.state.modalSubmitted}
                      handleSubmit={this.setModalSubmitted}
                      handleSubmitSuccess={() => {
                        this.get();
                        const { modals } = this.state;
                        modals.firmware = false;
                        this.setState({
                          modals,
                          modalSubmitted: false,
                        });
                      }}
                    />
                  </Modal>
                )
                : null}
            </div>
          </div>
        )
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
BundlesDetails.propTypes = {
  id: PropTypes.string,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(BundlesDetails);
